// extracted by mini-css-extract-plugin
export default {"Maindiv":"EditGender_Maindiv__qll8Q","container":"EditGender_container__FBp9v","saveBar":"EditGender_saveBar__CFVkm","stickyWrapper":"EditGender_stickyWrapper__N0p3j"};